module.exports = __webpack_public_path__ + "static/media/leadershipDarkMobile.caa41667.png";